import { defineMessages } from 'react-intl';


export default defineMessages({
    TERM_IN_YEARS_MESSAGE: {
        id: 'Mortgages.termInYears',
        defaultMessage: '{years, number} {years, plural, one {year} other {years}}',
    },
});